import { useState, useEffect } from "react";
import { Moon, Sun, User, LogOut, MessageCircle } from "lucide-react";
import "./css/Navbar.css";
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [darkMode, setDarkMode] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);  // State to control dropdown visibility
  const { loginWithRedirect, logout, user, isAuthenticated } = useAuth0();

  // Function to toggle dark mode
  useEffect(() => {
    document.documentElement.style.setProperty("--bg-light", darkMode ? "#1a202c" : "white");
    document.documentElement.style.setProperty("--text-light", darkMode ? "white" : "black");
    document.documentElement.style.setProperty("--dropdown-bg", darkMode ? "#2d3748" : "white");
    document.documentElement.style.setProperty("--dropdown-hover", darkMode ? "#4a5568" : "#f3f4f6");
  }, [darkMode]);

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen); // Toggle the dropdown menu visibility
  };

  return (
    <nav className={`navbar ${darkMode ? "dark" : "light"}`}>
      {/* Logo */}
      <div className="logo">
        <MessageCircle size={28} />
        <span>ChatApp</span>
      </div>

      {/* Navigation Links */}
      <div className="nav-links">
        <button><Link to="/"> Public Chat</Link></button>
        {/* <button><Link to="/privatechat">Private Chat</Link></button> */}
        <button><Link to="/startgame">Start Game</Link></button>
      </div>

      {/* Right Side: Dark Mode & Profile */}
      <div className="actions">
        <button onClick={() => setDarkMode(!darkMode)}>
          {darkMode ? <Sun size={20} /> : <Moon size={20} />}
        </button>
        {isAuthenticated && (

        <div className={`dropdown ${dropdownOpen ? "open" : ""}`}>
          <button onClick={handleDropdownToggle}>
            <User size={20} />
          </button>
          {/* Dropdown menu with conditional visibility */}
          <div className="dropdown-menu">
            <button>
              <User size={16} className="mr-2" /> <Link to="/editprofile">Profile</Link>
            </button>
            <button className="logout" onClick={() => logout({ returnTo: window.location.origin })}>
              <LogOut size={16} className="mr-2"></LogOut> Logout
            </button>
          </div>
        </div>
          )}
      </div>
    </nav>
  );
}
